import React from 'react';
import moment from 'moment';
let css = {
    wrapper: {
        width: 350,
        textAlign: 'center',
        backgroundColor: "yellow",
        padding: 10,
        border: "1px solid black"
    },
    linea: {
        display: 'flex',

        justifyContent: 'space-between'
    }
}
const Printer = props => {

    let items = Object.keys(props.lastItem.temporal);
    items = items.map(i => {
        return <div key={i} style={{ textAlign: 'left', borderBottom: "1px solid black", marginBottom: 10 }}>
            <div>{props.lastItem.temporal[i].liga}</div>
            <div>{props.lastItem.temporal[i].name}</div>

            <div style={css.linea}>
                <div>
                {moment(props.lastItem.temporal[i].time * 1000).format('MMM DD, YYYY|H:mm')}
                </div>
                <div style={{ textAlign: 'center' }}>
                    <b> {props.lastItem.temporal[i].option + " | " + props.format(props.lastItem.temporal[i].price)} </b>
                </div>
            </div>
            
            <div style={css.linea}>
                <div>
                    {props.language(props.lastItem.temporal[i].logro).text}
                </div>
                <div>
                  <b>   {props.language(props.lastItem.temporal[i].status).text} </b>
                </div>
            </div>
            {/* <div>{props.lastItem.temporal[i].logro}</div> */}

        </div>
    })
    return <div id="printer">

        <div style={css.wrapper}>
            <div style={{ borderBottom: '3px double black' }}>
                <span style={{ fontSize: 30, textAlign: 'center' }}>
                    <img className="img-logo" alt="" src={props.logo} width='100px' />
                    GRIFFON.<span style={{ color: "white" }}>BET</span></span>
                <div> <b>{props.lastItem.info.Agencia} </b></div>
                <div>{props.language().username + ": " + props.lastItem.info.Usuario}</div>
                <div> {moment(props.lastItem.info.Fecha * 1000).format('MMM DD, YYYY - H:mm')}</div>
                <div>
                    <b>
                        {"Id: #" + props.lastItem.info.ID + " " + props.language('Serial').text + ": " + props.lastItem.info.Serial}
                    </b>
                </div>
            </div>
            <div style={{ marginTop: 10 }}>
                {items}
            </div>
            <div style={css.linea}>
                <div>
                    <b> {props.language().stake + ": $" + props.lastItem.info.Monto} </b>
                </div>
                <div>
                    <b> {props.language().win + ": $" + props.lastItem.info.Ganancia} </b>
                </div>
            </div>
            <div> <b>{props.language().bets + ": " + props.lastItem.info.nEventos} </b></div>
            {/* <div>{JSON.stringify(props.lastItem.info)}</div> */}
            {/* <div>{JSON.stringify(props.lastItem.temporal)}</div> */}

        </div>

    </div>
}
export default Printer;


// WEBPACK FOOTER //
// ./src/components/Printer.js